import {
  APP_PERMISSION_KEYS,
  type AppPermissionKey,
  BUILTIN_APP_ROLE_KEYS,
  BUILTIN_ROLE_PERMISSIONS,
  type BuiltinAppRoleKey,
} from "./rolePermissions";

export type UserPermissionMap = Partial<Record<AppPermissionKey, boolean>>;

type UserLike = {
  is_super_admin?: boolean;
  app_role?: string | null;
  permissions?: UserPermissionMap;
};

function builtinRoleHas(role: string | null | undefined, perm: AppPermissionKey): boolean {
  if (!role || !BUILTIN_APP_ROLE_KEYS.includes(role as BuiltinAppRoleKey)) return false;
  return BUILTIN_ROLE_PERMISSIONS[role as BuiltinAppRoleKey].includes(perm);
}

/** Superadmin heeft alles; anders `user.permissions` van /api/me, of ingebouwde fallback. */
export function userHasPermission(user: UserLike | null | undefined, perm: AppPermissionKey): boolean {
  if (!user) return false;
  if (user.is_super_admin) return true;
  const map = user.permissions;
  if (map && perm in map) return !!map[perm];
  return builtinRoleHas(user.app_role ?? "deelnemer", perm);
}

export function allPermissionsTrueForSuperAdmin(): UserPermissionMap {
  const m: UserPermissionMap = {};
  for (const k of APP_PERMISSION_KEYS) m[k] = true;
  return m;
}
